import React, { PureComponent } from 'react';
import t from 'prop-types';
import cn from 'classnames';
import PopoverWrapper, {
  POSITIONS,
  APPEARANCE_DURATION,
} from '@mos-cat/popover-wrapper';

import THEME from './private/constants';

import './styles/Tooltip.pcss';

class Tooltip extends PureComponent {
  render() {
    const {
      wrapperClassName,
      className,
      children,
      position,
      theme,
      content,
      ...otherProps
    } = this.props;

    const contentClassNames = cn(
      'Tooltip',
      { [`Tooltip_${position}`]: true },
      `Block_${theme}`,
      `Block_${theme}_bordered`,
      className
    );

    const wrapperClassNames = cn(
      'TooltipWrapper',
      `TooltipWrapper_${theme}`,
      `TooltipWrapper_${theme}_bordered`,
      wrapperClassName
    );

    return (
      <PopoverWrapper
        position={position}
        className={wrapperClassNames}
        content={<div className={contentClassNames}>{content}</div>}
        {...otherProps}
      >
        {children}
      </PopoverWrapper>
    );
  }
}

if (process.env.NODE_ENV !== 'production') {
  Tooltip.propTypes = {
    children: t.node.isRequired,
    content: t.node.isRequired,
    wrapperClassName: t.string,
    className: t.string,
    theme: t.oneOf(Object.values(THEME)).isRequired,
    open: t.bool,
    position: t.oneOf(Object.values(POSITIONS)),
    /**
     * Флаг, указывающий на то, что поповер отображается для модального окна.
     */
    modal: t.bool,
    /**
     * Длительность (в миллисекундах) анимации при показе/сокрытии тултипа.
     */
    appearanceDuration: t.number,
    /**
     * Флаг, указывающий на необходимость тултипу автоматически менять положение, если он не
     * помещается в пределах экрана.
     */
    floating: t.bool,
    /**
     * Приравнивать или нет хэдер mos.ru к границе документа.
     */
    considerHeader: t.bool,
    /**
     * Отслеживать пололжение элемента, к которому привязан поповер.
     */
    trackChildPosition: t.bool,
  };
}

Tooltip.defaultProps = {
  className: '',
  wrapperClassName: '',
  position: POSITIONS.TOP,
  open: false,
  modal: false,
  appearanceDuration: APPEARANCE_DURATION,
  floating: false,
  considerHeader: false,
  trackChildPosition: true,
};

export { Tooltip as default, POSITIONS, THEME };
